const options = {
  INTERNATIONAL: "INTERNATIONAL",
  DOMESTIC: "DOMESTIC",
};

export default options;
